import { OrganizationService } from "../services/organizations.service";
import { useQuery } from "@tanstack/react-query";

export const useOrganizationUnitsByIds = ({
  ids,
  status,
  enabled = true,
}: {
  ids: string[];
  status: string;
  enabled?: boolean;
}) => {
  const {
    data: organizationUnits,
    isLoading: isLoadingOrganizationUnits,
    refetch: refetchOrganizationUnits,
  } = useQuery({
    queryKey: ["coyn-organization-units", ids],
    queryFn: () =>
      OrganizationService.findByIds({
        ids,
        status,
      }),
    enabled: ids.length > 0 && enabled,
  });

  return {
    organizationUnits,
    isLoadingOrganizationUnits,
    refetchOrganizationUnits,
  };
};
